import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useProject } from "@/components/projects";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PageHeader } from "@/components/layout";
import { TakeoffPilotJobForm } from "@/features/takeoff-pilot/takeoff-pilot-job-form";
import { useAppNavigate } from "@/lib/use-app-navigate";

export const Route = createFileRoute("/takeoffPilot/new")({
  component: NewTakeoffPilotPage,
});

export function NewTakeoffPilotPage() {
  const navigate = useAppNavigate();
  const { projectId, project, isLoading: isProjectLoading } = useProject();

  useEffect(() => {
    if (!isProjectLoading && !projectId) {
      navigate({ to: "/projects", title: "Projects" });
    }
  }, [isProjectLoading, projectId, navigate]);

  if (isProjectLoading) {
    return null;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="TakeoffPilot"
        description="Create a plan takeoff workflow with an optional schedule"
      />

      <Card className="max-w-4xl">
        <CardHeader>
          <CardTitle>Create TakeoffPilot Job</CardTitle>
          <CardDescription>
            {project ? (
              <>
                Creating in project: <strong>{project.name}</strong>. Pick one or more plan documents, optionally attach a schedule, and export the takeoff table.
              </>
            ) : (
              <>
                Pick one or more plan documents, optionally attach a schedule, and export the takeoff table.
              </>
            )}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <TakeoffPilotJobForm
            onSuccess={(jobId) =>
              navigate({
                to: "/takeoffPilot/$jobId",
                params: { jobId },
                title: "Takeoff Job",
              })
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
